export const exceedsMaxFileSize = (fileSize: number): boolean => {
  const MAX_FILE_SIZE = 10485760 // 10MB
  return fileSize > MAX_FILE_SIZE
}
